module.exports = {"231081100":"绥芬河镇","231081101":"阜宁镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231081.json
// module id = 721
// module chunks = 0